import { PauseIcon } from '@/components/icons/pause';
import { PlayIcon } from '@/components/icons/play';
import { Button } from './button';
import { useVideoStore } from '../hooks/use-video-store';
import { isMobile } from 'react-device-detect';
import { useIsMobileDevice } from '../hooks/use-is-mobile-device';

export function PlayPauseButton() {
  const { isPlaying, togglePlaying, toggleFullscreen } = useVideoStore(
    (state) => ({
      isPlaying: state.isPlaying,
      togglePlaying: state.togglePlaying,
      toggleFullscreen: state.toggleFullscreen,
    })
  );

  const isMobileDevice = useIsMobileDevice();

  function handleOnClick() {
    if (isMobile) {
      toggleFullscreen(isMobileDevice);
      togglePlaying();
    } else {
      togglePlaying();
    }
  }

  return (
    <Button
      label={isPlaying ? 'Pause video' : 'Play video'}
      icon={isPlaying ? <PauseIcon /> : <PlayIcon />}
      onClick={handleOnClick}
    />
  );
}
